import styled from "styled-components";

import { Flex } from "../../../components/Flex";
import { Rounded } from "../../../theme/Rounded";
import { Shadow } from "../../../theme/Shadow";
import { Spacing } from "../../../theme/Spacing";

/**
 * The same white/shadow/rounded panel the metric tiles use. Rate bars, the
 * origin breakdown, deal value and the trend charts used to float as bare
 * text and charts directly on the page background right below a grid of
 * cards, so the page switched visual language mid-scroll for no reason.
 */
export const ReportCard = styled(Flex)`
  border-radius: ${Rounded.md};
  background-color: ${({ theme }) => theme.white};
  box-shadow: ${Shadow.SM};
  padding: ${Spacing.m};
  flex-direction: column;
  gap: ${Spacing.s};
`;
